"use client";
import { useCompareStore } from "@/lib/store/Compare.store";
import { Drawer } from "antd";
import { useLocale, useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";
import { fetchData } from "../Collection";
import { RingLoader } from "react-spinners";
import { ProductListItemFragment } from "@/gql/graphql";
import { filterCateImg } from "@/components/Home2/Collection";
import { useRouter } from "@/navigation";
import { useChannel } from "@/context/channel";

function Index() {
	let { show, changeShow } = useCompareStore();

	const [CompareList, setCompareList] = useState([]);
	const t = useTranslations();
	const { compareIds, removeAllCompare, removeCompareProduct } = useCompareStore();
	const [loading, setLoading] = useState(false);
	const locale = useLocale();
	const { channel } = useChannel(locale);

	let router = useRouter();
	useEffect(() => {
		// if (show) {
		// 	return;
		// }

		if (!compareIds.length || !locale) return setCompareList([]);
		fetchData(compareIds, setLoading, locale, channel).then((res) => {
			// 按照 compareIds 顺序排序
			const sortedData = compareIds.map((id) => res.find((item) => item.node.id === id)).filter(Boolean); // 去掉可能未匹配到的数据

			// 更新排序后的结果
			setCompareList(sortedData);
		});
	}, [show, compareIds, locale, channel]);

	function removeId(id) {
		console.log(compareIds.length);

		removeCompareProduct(id);

		if (compareIds.length == 1) {
			setTimeout(() => {
				changeShow(false);
			}, 500);
		}
	}

	return (
		<Drawer
			placement={"bottom"}
			closable={false}
			onClose={() => changeShow(false)}
			open={show}
			height={"25%"}
			mask={false}
		>
			<div className="box-border flex h-full   w-full flex-col">
				<div className="w-full text-right">
					{" "}
					<i className="ri-close-fill cursor-pointer text-3xl" onClick={() => changeShow(false)}></i>
				</div>
				<div className="flex flex-1">
					<div className="box-border flex cursor-pointer  items-center justify-center gap-x-2  bg-white px-3 py-2 text-4xl group-hover:bg-black  max-lg:!text-xl">
						{t("nav.Compare1")} <span className="max-lg:hidden">{t("common.Products")}</span>
					</div>
					<div className="box-border flex h-full w-full flex-1  items-center gap-x-5 px-5 ">
						{CompareList.map((item) => (
							<CompareItem
								key={item.node.id}
								delFn={removeId}
								productItem={item.node as ProductListItemFragment}
							/>
						))}
					</div>
					<div className="flex flex-col  items-center justify-center">
						<div
							onClick={() => {
								changeShow(false);
								router.push("/compare");
							}}
							className="mb-4 box-border flex cursor-pointer items-center justify-center gap-x-2  rounded-sm bg-black px-5 py-2 text-3xl text-[18px] text-white"
						>
							{t("nav.Compare1")}
						</div>
						<span
							className="cursor-pointer underline"
							onClick={() => {
								removeAllCompare();
								changeShow(false);
							}}
						>
							{" "}
							{t("common.2404e3fb11a4cd4619b87d75ba56e345d8b0")}
						</span>
					</div>
				</div>
			</div>
		</Drawer>
	);
}
function CompareItem({ productItem, delFn }: { productItem: ProductListItemFragment; delFn: Function }) {
	return (
		<div className="relative ">
			<img
				src={filterCateImg(productItem.metadata)[0]?.url || "/image/img/product-2.webp"}
				alt="longshengmfg-logo"
				className=" h-[150px] w-[141px] rounded-sm object-cover"
			></img>

			<div
				onClick={() => delFn(productItem.id)}
				className=" absolute right-0 top-0 flex  h-6 w-6 cursor-pointer flex-col items-center justify-center rounded-full bg-white"
			>
				<i className="ri-close-line "></i>
			</div>
		</div>
	);
}

export default React.memo(Index);
